/* eslint-disable */
import React from 'react';
import { Flex, Image, Text, useColorModeValue } from '@chakra-ui/react';
import { HSeparator } from 'components/separator/Separator';

// === Import logo robot ResolveIT ===
import ResolveITRobot from 'assets/img/logo/logo.png'; // ganti sesuai path logo robot kamu

export function SidebarBrand() {
  const textColor = useColorModeValue('navy.700', 'white');

  return (
    <Flex
      align="center"
      direction="column"
      mt="32px"
      mb="24px"
      w="100%"
      px="12px"
    >
      {/* Logo robot + teks */}
      <Flex align="center" justify="center" mb="28px" gap="10px" w="100%">
        <Image
          src={ResolveITRobot}
          alt="ResolveIT Robot Logo"
          h={['48px', '54px', '60px']} // responsif: mobile - tablet - desktop
          w="auto"
          objectFit="contain"
          draggable={false}
        />
        <Text
          fontSize={['xl', '2xl']}
          fontWeight="extrabold"
          color={textColor}
          letterSpacing="wide"
          fontFamily="'Poppins', sans-serif"
        >
          Resolve<span style={{ color: '#6C63FF' }}>IT</span>
        </Text>
      </Flex>

      {/* Garis pemisah */}
      <HSeparator mb="24px" />
    </Flex>
  );
}

export default SidebarBrand;
